import React from "react";
import { ViewStyle } from "react-native";
import { ThePip } from "./styles";

type PipProps = {
	on: boolean;
	styles?: ViewStyle;
};

const Pip = ({ on, styles }: PipProps) => {
	const s = {
		...styles,
		opacity: !!on ? 1 : 0,
	};
	return <ThePip style={s} />;
};

export default Pip;
